import { render, staticRenderFns } from "./Savings.vue?vue&type=template&id=75d72da8&scoped=true&"
import script from "./Savings.vue?vue&type=script&lang=js&"
export * from "./Savings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d72da8",
  null
  
)

export default component.exports